import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useSDK } from '@ui/utils';
import type { Fraction } from 'bi-fraction';

export const useAgentLaunchReceiveAmount = ({
  purchaseAmount,
  ...props
}: {
  purchaseAmount: Fraction;
} & UseQueryOptions<Fraction>) => {
  const sdk = useSDK();

  return useQuery({
    queryKey: ['useAgentLaunchReceiveAmount', sdk, purchaseAmount],
    queryFn: async () => {
      return sdk
        .getAgentLauncher()
        .getInitialSupplyReceiveAmount(purchaseAmount);
    },
    ...props,
    enabled: props.enabled !== false && !!sdk,
  });
};
